const bonding = {
  hero: {
    badge: "Cosmetic Dentistry",
    title: "Dental Bonding",
    description:
      "Transform your smile with our expert dental bonding services. We use state-of-the-art techniques and tooth-colored resin to repair damaged, discolored, or misshapen teeth, providing a seamless, natural-looking result that enhances your smile and confidence.",
    ctas: {
      primary: "Book Consultation",
      secondary: "Learn About The Process",
    },
    stats: {
      value1: "97%",
      value2: "4.9",
      title: "97% Patient Satisfaction",
      subtitle: "Based on patient reviews",
    },
    imageAlt: "Dental bonding procedure",
  },
  benefits: {
    heading: "Benefits of Dental Bonding",
    intro: "Discover why patients choose dental bonding for their smile transformation",
    items: [
      {
        title: "Single Visit Procedure",
        description:
          "Complete your dental bonding in just one appointment, saving you time without compromising on quality.",
      },
      {
        title: "Minimally Invasive",
        description:
          "Preserve more of your natural tooth structure with this conservative cosmetic treatment option.",
      },
      {
        title: "Improved Appearance",
        description:
          "Enhance your smile by repairing chipped teeth, filling gaps, and matching your natural tooth color.",
      },
      {
        title: "Natural-Looking Results",
        description:
          "Our expert matching of resin to your tooth color ensures seamless, undetectable repairs.",
      },
      {
        title: "Instant Confidence",
        description:
          "Walk out with an immediately improved smile that boosts your self-esteem and confidence.",
      },
      {
        title: "Versatile Solution",
        description:
          "Address multiple cosmetic concerns with one versatile treatment that can be customized to your needs.",
      },
    ],
    bottomLinePrefix: "Want to learn if dental bonding is right for you?",
    bottomLineCta: "Schedule a consultation today",
  },
  process: {
    heading: "The Bonding Process",
    intro: "Our detailed approach ensures beautiful, natural-looking results",
    steps: [
      {
        number: "01",
        title: "Consultation & Assessment",
        description:
          "Our dentist will examine your teeth, discuss your goals, and determine if dental bonding is right for you.",
      },
      {
        number: "02",
        title: "Treatment Planning",
        description:
          "We'll select the ideal resin shade to match your natural teeth and plan the bonding procedure for optimal results.",
      },
      {
        number: "03",
        title: "Tooth Preparation",
        description:
          "The tooth surface is gently roughened and a conditioning liquid is applied to help the bonding material adhere.",
      },
      {
        number: "04",
        title: "Bonding Application",
        description:
          "The tooth-colored resin is applied, molded to the desired shape, and hardened with a special light.",
      },
      {
        number: "05",
        title: "Finishing Touches",
        description:
          "The bonded material is trimmed, shaped, and polished to match your natural teeth and ensure a comfortable bite.",
      },
    ],
    expected: {
      heading: "Expected Results",
      left: [
        "Natural-looking repair of chipped, cracked, or discolored teeth",
        "Closing of small gaps between teeth",
        "Improved appearance of misshapen teeth",
      ],
      right: [
        "Protection of exposed tooth roots due to receding gums",
        "Immediate results in just one appointment",
        "Enhanced smile appearance and confidence",
      ],
    },
  },
  faq: {
    heading: "Frequently Asked Questions",
    intro: "Everything you need to know about dental bonding",
    items: [
      {
        question: "How long does dental bonding last?",
        answer:
          "Dental bonding typically lasts between 3 to 10 years, depending on the location of the bonding, your oral habits, and how well you care for your teeth. Regular dental check-ups and good oral hygiene can help extend the life of dental bonding.",
      },
      {
        question: "Is the dental bonding procedure painful?",
        answer:
          "No, dental bonding is typically a painless procedure. In most cases, anesthesia isn't even necessary unless the bonding is being used to fill a decayed tooth, the tooth needs to be drilled to change its shape, or the chip is near the nerve.",
      },
      {
        question: "How much does dental bonding cost?",
        answer:
          "The cost of dental bonding varies depending on the extent of the procedure, the number of teeth being treated, and your location. Generally, it is one of the most affordable cosmetic dental procedures available. We provide detailed cost estimates during your consultation.",
      },
      {
        question: "How long does the bonding procedure take?",
        answer:
          "Dental bonding usually takes between 30 to 60 minutes per tooth. The entire process can often be completed in a single office visit, making it a convenient option for busy patients.",
      },
      {
        question: "How do I care for bonded teeth?",
        answer:
          "Care for bonded teeth as you would your natural teeth with regular brushing and flossing. Avoid biting hard objects like ice, pens, or fingernails, and limit consumption of staining substances like coffee, tea, and tobacco. Regular dental check-ups are essential for maintaining your bonded teeth.",
      },
      {
        question: "Can dental bonding fix all types of dental problems?",
        answer:
          "Dental bonding is versatile but not suitable for all dental issues. It works well for minor cosmetic improvements, small chips, gaps, and discoloration. For more extensive damage or for teeth that experience heavy biting forces, other treatments like veneers or crowns might be more appropriate.",
      },
      {
        question: "Is dental bonding reversible?",
        answer:
          "Yes, dental bonding is generally reversible since it doesn't require removing much, if any, of the original tooth enamel. If you decide to try a different cosmetic treatment in the future, the bonding material can be removed without permanent damage to your natural tooth.",
      },
    ],
    bottomLine: "Still have questions about dental bonding?",
    cta: "Contact Us",
  },
};

export default bonding;

